import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EEPlaceholder from '@/components/Sections/EEPlaceholder';
import styles from './PremiumArticleEloquaForm.module.scss';
import EloquaForm from 'components/Sections/EloquaForm/EloquaForm';
import { ComponentProps } from 'lib/component-props';
import { getCookie, setCookie } from 'hooks/useCookie';
import { articlesActions, getHasPremiumArticleEloquaForm } from '@/store/articles';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { useArticle } from 'hooks/useArticle';
import AnimateHeight, { Height } from 'react-animate-height';

type PremiumArticleEloquaFormProps = ComponentProps & {};

const PremiumArticleEloquaForm: React.FC<PremiumArticleEloquaFormProps> = ({ rendering }) => {
  const { sitecoreContext } = useSitecoreContext();
  const dispatch = useDispatch();
  const hasPremiumArticleEloquaForm = useSelector(getHasPremiumArticleEloquaForm);
  const [showForm, setShowForm] = useState(false);
  const [height, setHeight] = useState<Height>('auto');
  const { data, config } = useArticle();
  const formData = config?.premiumFormDataSource;
  const hasFormData = !!formData;

  useEffect(() => {
    const hasCookie = !!getCookie('abrdn-premium-article');

    if (hasFormData && !hasCookie && data?.articleData?.premiumContent?.boolValue === true) {
      dispatch(articlesActions.setHasPremiumArticleEloquaForm(true));
      setShowForm(true);
    }
  }, [data?.articleData?.premiumContent, dispatch, hasFormData]);

  const onSubmit = () => {
    const value = {
      sitename: sitecoreContext.site?.name,
      language: sitecoreContext.language,
    };
    setCookie('abrdn-premium-article', JSON.stringify(value), 30);

    setHeight(0);
    setTimeout(() => {
      dispatch(articlesActions.setHasPremiumArticleEloquaForm(false));
      setShowForm(false);
      const articleBodyElement = document.querySelector(
        '.abrdn-article-body'
      ) as HTMLElement | null;
      if (articleBodyElement) {
        articleBodyElement.focus({ preventScroll: true });
      }
    }, 3000);
  };

  if (hasPremiumArticleEloquaForm && !showForm) {
    return <EEPlaceholder>Premium Article Eloqua Form</EEPlaceholder>;
  }

  return (
    showForm && (
      <AnimateHeight height={height} delay={2700} duration={300}>
        <div id="premium-eloqua-form" className={`position-relative`}>
          <div className={styles['faded-top']} />
          <EloquaForm
            fields={{ formJson: formData }}
            rendering={rendering}
            background="background-black"
            icon
            className="px-2 px-md-4 py-4"
            onSubmitSuccess={onSubmit}
          />
        </div>
      </AnimateHeight>
    )
  );
};

export default PremiumArticleEloquaForm;
